<template>
  <UIModal class="ModalLogout" ariaLabel="Signing out" :isDismissable="false">
    <template #content-container>
      <div class="ModalLogoutContent">
        <UISpinner size="md" class="PageLogout__loader" />
        <h1 class="PageLogout__title">Signing out...</h1>
      </div>
    </template>
  </UIModal>
</template>

<script lang="ts" setup>
import { UIModal, UISpinner } from '@foundever/ui-lib'
</script>
<style lang="scss">
.ModalLogout {
  display: flex;
  flex-direction: column;
  align-items: center;

  .ModalLogoutContent {
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: var(--text-primary);
    font-size: 18px;
    font-weight: 400;
    font-family: 'Foundever', sans-serif;
    gap: 1rem;

    @include sm {
      padding: 3rem;
    }
  }

  .PageLogout__title {
    font-weight: 500;
    font-size: 20px;
    line-height: 28px;
    font-family: $font-foundever-sans;

    @include sm {
      font-size: 24px;
      line-height: 32px;
    }
  }
}
</style>
